import { atomWithReset } from "jotai/utils";

export interface RescheduleRecurrenceOldSession {
  /** Agendamento de origem — enviado como codAgendamentoOrigem no reagendamento. */
  codAgendamento: number;
  /** Data da sessão atual (yyyy-MM-dd) — o "de" do remanejamento. */
  data: string;
  horaInicio: string;
  codUnidade?: number;
}

export interface RescheduleRecurrenceContext {
  /** Recorrência de origem — passada ao reagendarRecorrencia para remapear o bloco. */
  codAgendamentoRecorrente: number;
  /**
   * Sessões pendentes (não canceladas) da data tocada em diante, em ordem crescente
   * de data, para montar o "de → para". As anteriores à sessão tocada ficam fora.
   */
  oldSessions: RescheduleRecurrenceOldSession[];
}

/**
 * Contexto do fluxo de reagendar uma recorrência inteira. As demais informações
 * (padrão, novo horário, novas datas, paciente) reutilizam os atoms da criação
 * (recurringAppointmentFormAtom/recurringSlotAtom/recurringSessionsAtom/
 * recurringPatientAtom) — este atom carrega só o que é específico do remanejamento.
 */
export const rescheduleRecurrenceAtom = atomWithReset<RescheduleRecurrenceContext>({
  codAgendamentoRecorrente: 0,
  oldSessions: [],
});
